import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import usuarios from "../../api/usuarios";
import { errorToString } from "../../helpers/funcoes";
import { Titulo } from "../Titulo";

export function UsuariosConta() {
  const navigate = useNavigate();

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string>();
  const [success, setSuccess] = useState<string>();

  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (novaSenha !== confirmarSenha) {
      setError("A nova senha e a confirmação devem ser iguais.");
      return;
    }

    setSaving(true);
    setError(undefined);
    setSuccess(undefined);

    const payload = {
      senhaAtual,
      novaSenha,
    };

    usuarios
      .changeMyPassword(payload)
      .then(() => {
        setSuccess("Senha alterada com sucesso!");
        setSenhaAtual("");
        setNovaSenha("");
        setConfirmarSenha("");
      })
      .catch((err) => setError(errorToString(err)))
      .finally(() => setSaving(false));
  };

  return (
    <Form onSubmit={onSubmit}>
      <Titulo text="Minha Conta" />
      {error && (
        <Alert color="danger" data-cy="alert">
          {error}
        </Alert>
      )}
      {success && (
        <Alert color="success" data-cy="success">
          {success}
        </Alert>
      )}
      <FormGroup row>
        <Label for="txtSenhaAtual" sm={2}>
          Senha Atual:
        </Label>
        <Col sm={10}>
          <Input
            id="txtSenhaAtual"
            type="password"
            data-cy="senhaAtual"
            value={senhaAtual}
            onChange={(e) => setSenhaAtual(e.target.value)}
            required
            disabled={saving}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for="txtNovaSenha" sm={2}>
          Nova Senha:
        </Label>
        <Col sm={10}>
          <Input
            id="txtNovaSenha"
            type="password"
            data-cy="novaSenha"
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
            required
            disabled={saving}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for="txtConfirmarSenha" sm={2}>
          Confirmar Nova Senha:
        </Label>
        <Col sm={10}>
          <Input
            id="txtConfirmarSenha"
            type="password"
            data-cy="confirmarSenha"
            value={confirmarSenha}
            onChange={(e) => setConfirmarSenha(e.target.value)}
            required
            disabled={saving}
          />
        </Col>
      </FormGroup>
      <Row>
        <Col sm={6}>{saving && <Spinner />}</Col>
        <Col sm={6} className="text-end">
          <Button
            type="button"
            color="secondary"
            className="me-2"
            disabled={saving}
            onClick={() => navigate(-1)}
          >
            Cancelar
          </Button>
          <Button type="submit" disabled={saving}>
            Alterar Senha
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
